$(function() {
  var navbars, setAriaAndClass, toggle;
  toggle = function() {
    var btn, menu;
    btn = $(this);
    menu = btn.parents('.navbar').find('.navbar-collapse');
    if (menu.is(':visible')) {
      menu.stop().slideUp(300, function() {
        return setAriaAndClass(menu, btn);
      });
    } else {
      menu.stop().slideDown(300, function() {
        return setAriaAndClass(menu, btn);
      });
    }
  };
  setAriaAndClass = function(menu, btn) {
    var isVisible;
    isVisible = menu.is(':visible');
    menu.attr('aria-expanded', isVisible);
    btn.attr('aria-expanded', isVisible);
    if (isVisible) {
      menu.removeClass('collapsed');
      btn.addClass('open');
    } else {
      menu.addClass('collapsed');
      btn.removeClass('open');
    }
  };
  return navbars = $("nav.navbar").each(function(idx, nb) {
    var $nb, btn, menu;
    $nb = $(nb);
    menu = $nb.find('.avbar-collapse');
    btn = $nb.find('.navbar-toggle');
    setAriaAndClass(menu, btn);
    return btn.click(toggle);
  });
});
